import { CommonService } from '@/services/Common.service';
import { AuthenService } from '@/services/authen.service';

export class ShatenService {
  private baseAPI = process.env.VUE_APP_API_URL;
  private commonAPI = process.env.VUE_APP_API_COMMON_URL;
  private authService = new AuthenService();
  private commonService = new CommonService();

  constructor() {
  }

  get headers() {
    return {
      'Content-Type': 'application/json',
      'auth': localStorage.getItem('token'),
    };
  }

  public async getGroupList() {
    const { result, error } = await this.commonService.get(`${this.baseAPI}/company/group`);
    if (result) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getGroupList');
      return;
    }
  }

  public async getShatenList(groupCd: string) {
    const { result, error } = await this.commonService.get(`${this.baseAPI}/company/${groupCd}/shaten`);
    if (result) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getShatenList');
      return;
    }
  }


  public async getShuukeiList(groupCd: string, shatenCd: string) {
    const q = `?q=groupCd=${groupCd},shatenCd=${shatenCd}`;
    const { result, error } = await this.commonService.get(`${this.baseAPI}/company/shaten-jyouhou-kanri${q}`);
    if (result) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getShuukeiList');
      return;
    }
  }

  public async addCompany(data: any) {
    const { result, error } = await this.commonService.post(`${this.baseAPI}/company`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'addCompany');
      return;
    }
  }

  public async getCompanyList() {
    const { result, error } = await this.commonService.get(`${this.baseAPI}/company`);
    if (result) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getCompanyList');
      return;
    }
  }

  public async updateCompany(data: any) {
    const { result, error } = await this.commonService.put(`${this.baseAPI}/company`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'updateCompany');
      return;
    }
  }

  public async getCompanyKyoten(groupCd: string, shatenCd: string) {
    const q = `?q=groupCd=${groupCd},shatenCd=${shatenCd}`;
    const { result, error } = await this.commonService.get(`${this.baseAPI}/company/kyoten-jyouhou${q}`);
    if (result) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getCompanyList');
      return;
    }
  }

  public async saveKyotenJyouhou(data: any) {
    const { result, error } = await this.commonService.post(`${this.baseAPI}/company/kyoten-jyouhou`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'saveKyotenJyouhou');
      return;
    }
  }

  public async createCompanyAccount(data: any) {
    const { result, error } = await this.commonService.post(`${this.baseAPI}/company/account`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'createCompanyAccount');
      return;
    }
  }

  async shakenInspectClone(data: any) {
    const { result, error } = await this.commonService.post(`${this.baseAPI}/shaken/inspect/clone`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'shakenInspectClone');
      return;
    }
  }

  async getSeibiMenuInspectFeeMap(versionId: number) {
    const path  = `/company/seibi-menu-inspect-seibi-fee-map?versionId=${versionId}`;
    const { result, error } = await this.commonService.get(`${this.baseAPI}${path}`);
    if (result && result.status === 200) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getSeibiMenuInspectFeeMap');
      return [];
    }
  }

  async saveSeibiMenuInspectFeeMap(data: any) {
    const path  = "/company/seibi-menu-inspect-seibi-fee-map";
    const { result, error } = await this.commonService.put(`${this.baseAPI}${path}`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'saveSeibiMenuInspectFeeMap');
      return;
    }
  }

  async getInspectMenuFee(versionId: number) {
    const path  = `/company/inspect-seibi-fee-table?versionId=${versionId}`;
    const { result, error } = await this.commonService.get(`${this.baseAPI}${path}`);
    if (result && result.status === 200) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getInspectMenuFee');
      return [];
    }
  }

  public async getShatenExtension( versionId: number ) {
    const path  = `/company/shaten-extension?versionId=${versionId}`;
    const { result, error } = await this.commonService.get(`${this.baseAPI}${path}`);
    if (result && result.status === 200) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getShatenExtension');
      return [];
    }
  }

  public async saveShatenExtension( versionId: number, data: any) {
    const path = `/company/update-shaten-extension/${versionId}`;
    const { result, error } = await this.commonService.put(`${this.baseAPI}${path}`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'saveShatenExtension');
      return;
    }
  }

  public async saveShatenSknExtension( versionId: number, data: any[]) {
    const path = `/company/update-shaten-skn-extension/${versionId}`;
    const { result, error } = await this.commonService.put(`${this.baseAPI}${path}`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'saveShatenExtension');
      return;
    }
  }

  public async getShatenSknExtension( versionId: number ) {
    const path  = `/company/shaten-skn-extension?versionId=${versionId}`;
    const { result, error } = await this.commonService.get(`${this.baseAPI}${path}`);
    if (result && result.status === 200) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getShatenSknExtension');
      return [];
    }
  }

  // 2022-01-31 morisako kobac-free mod [START]
  public async saveFreeOfCharge( data: any ) {
    const path = `/company/free-of-charge`;
    const { result, error } = await this.commonService.put(`${this.baseAPI}${path}`, data);
    if (result && result.status === 200) {
      return result.status;
    } else {
      this.authService.handleError(error, 'saveFreeOfCharge');
      return;
    }
  }

  public async getMSknFreeOfCharge( form: any ) {
    const path  = `/company/free-of-charge`;
    let arrQParam = [];
    let q = "";
    if (form.groupCd) {
        arrQParam.push("group_cd=" + form.groupCd);
    }
    if (form.shatenCd) {
        arrQParam.push("shaten_cd=" + form.shatenCd);
    }
    if (form.kyotenCd) {
        arrQParam.push("kyoten_cd=" + form.kyotenCd);
    }
    if (form.version) {
        arrQParam.push("version_id=" + form.version);
    }
    if (form.sknInspectSeibiFeeId) {
        arrQParam.push("skn_inspect_seibi_fee_id=" + form.sknInspectSeibiFeeId);
    }
    if (arrQParam.length > 0) {
        q += '?q=' + arrQParam.join(",");
    }
    const { result, error } = await this.commonService.get(`${this.baseAPI}${path + q}`);
    if (result && result.status === 200) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getMSknFreeOfCharge');
      return [];
    }
  }
  // 2022-01-31 morisako kobac-free mod [END]
}
